import { render, staticRenderFns } from "./FuneralTypeService.vue?vue&type=template&id=d2524b78"
import script from "./FuneralTypeService.vue?vue&type=script&lang=js"
export * from "./FuneralTypeService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports